import React, { Component } from 'react'
import Select from 'react-select';
import { getUser } from '../../../actions/session';
import axios from 'axios';
import { BILLING_LISTING, BILLING_CREATED,RATEDECK_COMPLETE,ASSIGN_RATEDECK, LOGIN_URL, GET_RATEDECK, ACCOUNT_RATEDECK_DOWNLOAD } from '../../../config/rest_endpoints';
import { Notifications } from '../../common/notification';
import CustomLoader from '../../common/loader';
import { RC_LOAD_LOGIN } from '../../routers/RouteConstants';
import { Link, withRouter } from 'react-router-dom';
import CustomModal from '../../common/modal';
import AddAccountRateDeck from './components-modal/addAccountRateDeck';

class Billing extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            userId: this.props.userId,
            name:this.props.accountName,
            charges: '',
            rate: '',
            selectedCharges: '',
            selectedtype: '',
            optionsConnectCharges: [
                { value: '6s', label: '6s' },
                { value: '12s', label: '12s' },
                { value: '18s', label: '18s' },
                { value: '24s', label: '24s' },
                { value: '30s', label: '30s' },
                { value: '60s', label: '60s' },
            ],
            optionsAccountType: [
                { value: 'Postpay', label: 'Postpay' },
                { value: 'Prepay', label: 'Prepay' }
            ],
            roundMethod: [
                { value: '*up', label: 'Up' },
                { value: '*down', label: 'Down' }
            ],
            selectRoundMethod: '',
            roundDigits: [
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' }
            ],
            selectRoundDigits: '',
            subsequent: [
                { value: '6s', label: '6s' },
                { value: '12s', label: '12s' },
                { value: '18s', label: '18s' },
                { value: '30s', label: '30s' },
                { value: '60s', label: '60s' },
            ],
            subsequentSelect: '',
            billList: [],
            rateDeckList:[],
            agentList:[],
            msg: '',
            isGetting: false,
            isError: false,
            rateSelect:'',
            rateList:[],
            type:this.props.checkType,
            isGetting:false,
            isUploadModal:false,
            isLoad:false
        }
        this.handleSelectAccount = this.handleSelectAccount.bind(this)
        this.handleSelectCharges = this.handleSelectCharges.bind(this)
        this.onHandleChange = this.onHandleChange.bind(this)
        this.onSubmitBill = this.onSubmitBill.bind(this)
        this.handleRoundDigitsSelect = this.handleRoundDigitsSelect.bind(this)
        this.handleRoundMethodSelect = this.handleRoundMethodSelect.bind(this)
        this.handleSubsequentSelect = this.handleSubsequentSelect.bind(this)
        this.handleSelectRate = this.handleSelectRate.bind(this)
        this.onAssignRateDeck = this.onAssignRateDeck.bind(this)
        this.openUploadModal = this.openUploadModal.bind(this)
        this.closeUploadModal = this.closeUploadModal.bind(this)
        this.billingListing = this.billingListing.bind(this)
    }

    componentDidMount() {
        this.billingListing()
        this.getListRate()
        this.getRateDeck()
    }

    openUploadModal() {
        this.setState({isUploadModal:true})
    }

    closeUploadModal() {
        this.setState({isUploadModal:false,  },()=>{
            this.billingListing()
        })
    }

    onHandleChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelectCharges(selectedCharges) {
        this.setState({ selectedCharges });
        console.log(`Option selectedCharges:`, selectedCharges);
    };

    handleSelectAccount(selectedtype) {
        this.setState({ selectedtype });
        console.log(`Option selectedtype:`, selectedtype);
    };

    handleSubsequentSelect(subsequentSelect) {
        this.setState({ subsequentSelect })
    }

    handleRoundMethodSelect(selectRoundMethod) {
        this.setState({ selectRoundMethod })
    }

    handleRoundDigitsSelect(selectRoundDigits) {
        this.setState({ selectRoundDigits })
    }

    handleSelectRate(rateSelect) {
        this.setState({rateSelect},()=>{
            console.log('rateSelect :>> ', rateSelect);
        })
    }

    getListRate() {
        const { User } = this.state
        this.setState({isGetting:true})
        var headers = { 'Authorization': "Bearer " + User.token }
        axios.get(RATEDECK_COMPLETE, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                resp.map((row,idx)=>{
                        row['label'] = row['csvName']
                        row['id'] = row['id']
                        return row
                })
                this.setState({rateList:resp, isGetting:false})
            }
          
        }).catch(err => {
           console.log('err :>> ', err);
           this.setState({isGetting:false})
        })
    }

    getRateDeck() {
        const { User, userId } = this.state
        this.setState({isGetting:true})
        var headers = { 'Authorization': "Bearer " + User.token }
        axios.get(`${GET_RATEDECK}/${userId}/pricing/ratedecks`, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
               this.setState({rateDeckList:resp})
            }
          
        }).catch(err => {
           console.log('err :>> ', err);
           this.setState({isGetting:false})
        })
    }

    onAssignRateDeck() {
        const { User,userId,rateSelect } = this.state
        var rateDeckId = rateSelect['id']
        var headers = { 'Authorization': "Bearer " + User.token }
        axios.get(`${ASSIGN_RATEDECK}/${userId}/ratedeck/${rateDeckId}/assign`, { headers }).then(res => {
            if (res) {
              console.log('res :>> ', res);
              var resp =res.data['sub-message']
              this.billingListing()
              Notifications.notify(resp, "Assign", "success")
            }
          
        }).catch(err => {
           console.log('err :>> ', err);
           Notifications.notify(err, "Failed", "error")

        })
    }

    billingListing() {
        const { User, userId } = this.state
        console.log('userId :>> ', userId);
        this.setState({
            isGetting: true
        })
        var headers = { 'Authorization': "Bearer " + User.token }
        axios.get(`${BILLING_LISTING}/${userId}/pricing`, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                this.setState({
                    billList: res.data.data,
                    isGetting: false,
                    isError: false
                })
            }
            else {
                this.setState({ msg: '', isError: true, isGetting:false })
                Notifications.notify("Failed to created", "error", "errors")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    rateDeckDownload(file) {
        const { User } = this.state
        var headers = { 'Authorization': "Bearer " + User.token }
        axios.get(`${ACCOUNT_RATEDECK_DOWNLOAD}?file=${file}`, { headers }).then(res => {
            let content = res.headers['content-disposition']
            if (res) {
                var resp = res.data
                var short = content.split("filename=")[1]
                var filename = short.replace(/['"]+/g, '')
                const url = window.URL.createObjectURL(new Blob([resp])) 
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${filename}.csv`)
                document.body.appendChild(link)
                link.click()
              
            }
            else {
                this.setState({ msg: '', isError: true, isGetting:false })
                Notifications.notify("Failed to created", "error", "errors")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    onSubmitBill() {
        const { User, userId, charges, rates, selectedCharges, subsequentSelect, selectRoundMethod, selectRoundDigits } = this.state
        console.log('userId :>> ', userId);
        var billingAdd = {
            "accountID": userId,
            "initialInc": selectedCharges.value,
            "connectFee": parseFloat(charges),
            "ratePerMin": parseFloat(rates),
            "subsequentInc": subsequentSelect.value,
            "roundingMethod": selectRoundMethod.value,
            "roundingDigits": parseInt(selectRoundDigits.value)
        }
        this.setState({isLoad:true})
        console.log('billingAdd', billingAdd)
        var headers = { 'Authorization': "Bearer " + User.token }
        axios.post(`${BILLING_CREATED}/pricing/create`, billingAdd, { headers }).then(res => {
            console.log('res :', res);
            if (res) {
                this.setState({
                    msg: res.data.message,
                    isLoad:false
                })
                Notifications.notify(this.state.msg, "Created", "success")
                this.billingListing()
            }
        }).catch(err=>{
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false,
                isLoad:false
            })
        })
    }

    renderBillTable() {
        const {billList,isError} = this.state
        var nullData = (
          
            <div className="ml-4 mt-2" >
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if(billList === null || billList.length === 0){
            return nullData
        }
        else {
            if(this.state.type === 'flatrate') {
                return (
                
                    <tr>
                        <td style={{textAlign:'center'}}>{billList.connectFee}</td>
                        <td style={{textAlign:'center'}}>{billList.ratePerMin}</td>
                        <td style={{textAlign:'center'}}>{billList.initialInc}</td>
                        <td style={{textAlign:'center'}}>{billList.subsequentInc}</td>
                        <td style={{textAlign:'center'}}>{billList.roundingDigits}</td>
                        <td style={{textAlign:'center'}}>{billList.roundingMethod}</td>
                    </tr>
                    )
            } else {
                return nullData
            }
          
        }
    }

    renderRateDeckList() {
        const {billList,isError,rateDeckList} = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if(billList === null || billList.length === 0 ){
            return nullData
        }
        else if(Array.isArray(billList)) {
            return billList.map((row,idx)=>{
                return(
                    <tr key={idx}>
                        <td>{row.csvName}</td>
                        <td>{row.connectFee}</td>
                        <td>{row.initialInc}</td>
                        <td>{row.subsequentInc}</td>
                        <td>{row.roundingMethod}</td>
                        <td>{row.roundingDigits}</td>
                        <td>{row.effectiveDate}</td>
                        <td>{row.createDate}</td>
                        <td>{row.status === 'pending' ? <span className="badge badge-info">Pending</span> : row.status === 'active' ? <span className="badge badge-success">Active</span> : <span className="badge badge-danger">In-active</span>}</td>
                        <td className="text-center">
                            <Link><i className="icon-file-download" onClick={this.rateDeckDownload.bind(this, row.csvName)}></i></Link>
                        </td>
                    </tr>
                )
            })
        }
        else if(rateDeckList.length) {
            return rateDeckList.map((row,idx)=>{
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.csvName}</td>
                        <td style={{textAlign:'center'}}>{row.connectFee}</td>
                        <td style={{textAlign:'center'}}>{row.initialInc}</td>
                        <td style={{textAlign:'center'}}>{row.subsequentInc}</td>
                        <td style={{textAlign:'center'}}>{row.roundingMethod}</td>
                        <td style={{textAlign:'center'}}>{row.roundingDigits}</td>
                        <td style={{textAlign:'center'}}>{row.effectiveDate}</td>
                        <td style={{textAlign:'center'}}>{row.createDate}</td>
                        <td style={{textAlign:'center'}}>{row.status === 'pending' ? <span className="badge badge-info">Pending</span> : row.status === 'active' ? <span className="badge badge-success">Active</span> : <span className="badge badge-danger">In-active</span>}</td>
                        <td className="text-center">
                        <Link><i className=" edit-button icon-file-download" onClick={this.rateDeckDownload.bind(this, row.csvName)}></i></Link>
                        </td>
                    </tr>
                )
            })
        }
    }

    render() {
        const {isUploadModal,rateList,type,rateSelect, subsequentSelect, subsequent, selectRoundDigits, roundDigits, selectRoundMethod, roundMethod, charges, rates, selectedOption, optionsConnectCharges, optionsAccountType, selectedCharges, selectedtype, billList, isGetting, isError } = this.state
        var tabVal = type
        console.log('type :>> ', tabVal.length);
        let uploadModal = {
            details: {
                info: `Add RateDeck`,
                msg: <AddAccountRateDeck id={this.state.userId} listing={this.billingListing} name={this.state.name} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeUploadModal },
            cancelBtn: { label: "Cancel", action: this.closeUploadModal }
        }

        return (
            <div>
                 <CustomModal
                    visibility={isUploadModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    modalSize="large"
                    details={uploadModal.details}
                    showBtns={false}
                    cancelBtn={uploadModal.cancelBtn}
                    crossBtn={uploadModal.crossBtn}
                />
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body border-left-dark-alpha border-right-dark-alpha ">
                    <ul className="nav nav-tabs nav-tabs-top nav-justified border fs-16">
                        <li className="nav-item"><a href="#top-justified-tab1"  className={`nav-link ${type === 'flatrate' ? 'active' : ''}`} data-toggle="tab">Flat Rate <i className="icon-stats-growth icon-2x ml-2 pricing-icons"></i></a></li>
                        <li className="nav-item"><a  href="#top-justified-tab2" className={`nav-link ${type.length > 8 ?  'active' : '' }`} data-toggle="tab">Rate Deck <i className="icon-design icon-2x ml-2 pricing-icons"></i></a></li>
                    </ul>

                    <div className="tab-content">
                        <div className={`tab-pane fade ${type === 'flatrate' ? 'active show' :''}`} id="top-justified-tab1">
                            <div className="card card-body">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label style={{fontWeight:'400',fontSize:'16px'}}>Connect Charges</label>
                                                <input type="number" className="form-control" name="charges" value={charges} onChange={this.onHandleChange} placeholder="Enter charges" />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label  style={{fontWeight:'400',fontSize:'16px'}}>Rate Per Min</label>
                                                <input type="number" className="form-control" name="rates" value={rates} onChange={this.onHandleChange} placeholder="Enter rate" />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label  style={{fontWeight:'400',fontSize:'16px'}}>Initial Increment</label>
                                                <Select
                                                    value={selectedCharges}
                                                    onChange={this.handleSelectCharges}
                                                    options={optionsConnectCharges}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* row 1 */}
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label  style={{fontWeight:'400',fontSize:'16px'}}>Subsequent Increment</label>
                                                <Select
                                                    value={subsequentSelect}
                                                    onChange={this.handleSubsequentSelect}
                                                    options={subsequent}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label  style={{fontWeight:'400',fontSize:'16px'}}>Rounding Method</label>
                                                <Select
                                                    value={selectRoundMethod}
                                                    onChange={this.handleRoundMethodSelect}
                                                    options={roundMethod}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label  style={{fontWeight:'400',fontSize:'16px'}}>Rounding Digits</label>
                                                <Select
                                                    value={selectRoundDigits}
                                                    onChange={this.handleRoundDigitsSelect}
                                                    options={roundDigits}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* row 2 */}
                                    <div className="row">
                                        <div className="col-md-4 ml-auto">
                                            <div className="mt-2">
                                                <button type="submit" className="main-button btn btn-primary btn-sm float-right" onClick={this.onSubmitBill} >Add Pricing <i className={this.state.isLoad ? "icon-spinner4 spinner ml-1 " : "icon-coins ml-1 icon-1x"}></i> </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* row 3 */}
                                    <div className="card border-0" style={{zIndex:'0'}}>
                                        <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                                            <div className="datatable-header">
                                                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                                  
                                                </div>
                                            </div>
                                            <div className="datatable-scroll" style={{ overflowX: 'auto' }}>
                                                <table style={{border:'1px solid #ddd',borderTop:'none',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                                    <thead>
                                                        <tr className="stickeyHeader">
                                                            <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Connect Charges</th>
                                                            <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Rate Per Min</th>
                                                            <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Initial Increment</th>
                                                            <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Subsquent Increment</th>
                                                            <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Rounding Digits</th>
                                                            <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Rounding Method</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {isGetting ? <CustomLoader /> : this.renderBillTable()}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane fade ${type.length > 8  ? 'active show' :''} `} id="top-justified-tab2">
                        <div className="card card-body">
                                <div className="mt-0 mb-0 card-header p-0 header-elements-inline">
                                    {/* <h4 className="card-title">Assign RateDeck</h4> */}
                                    <button type="submit" className="main-button btn btn-success btn-sm ml-auto mr-3" onClick={this.openUploadModal} >Upload Ratedeck <i className="icon-coins ml-1 icon-1x"></i> </button>

                                </div>
                                <div className="card-body">
                                    {/* <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Rate List</label>
                                                <Select
                                                    value={rateSelect}
                                                    onChange={this.handleSelectRate}
                                                    options={rateList}
                                                />
                                            </div>
                                        </div>
                                       
                                    </div>
                                   
                                    <div className=" ml-auto">
                                        <button type="submit" className="btn bg-theme" onClick={this.onAssignRateDeck} >Assign Rate <i className="icon-coins ml-1 icon-1x"></i> </button>
                                    </div> */}
                                   
                                        <div id="DataTables_Table_0_wrapper " className="mt-0 dataTables_wrapper no-footer">
                                            <div className="datatable-header">
                                                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                                  
                                                </div>
                                            </div>
                                            <div className="datatable-scroll" style={{overflowX: 'auto'}}>
                                                <table style={{border:'1px solid #ddd',borderTop:'0px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                                <thead>
                                                    <tr className="stickeyHeader">
                                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Csv Name</th>
                                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Connect Fee</th>
                                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Initial Inc</th>
                                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Subsequent Inc</th>
                                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Rounding Method</th>
                                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Rounding Digits</th>
                                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Effective Date</th>
                                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Record Date</th>
                                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Status</th>
                                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Download</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                     {isGetting ? <CustomLoader /> :  this.renderRateDeckList()}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }
}
export default withRouter(Billing)